import { Controller } from 'react-hook-form';

import { InputPhone } from '../InputPhone';

export const InputPhoneController = ({ control, name, ...props }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <InputPhone
          value={value}
          onChange={onChange}
          error={Boolean(error)}
          errorMessage={error?.message}
          {...props}
        />
      )}
    />
  );
};
